'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledFlexboxGrid = exports.gridConfig = undefined;

var _propTypes = require('prop-types');

var gridConfig = exports.gridConfig = {
  // eslint-disable-line
  rowWidth: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  gutter: (0, _propTypes.oneOfType)([(0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]), (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.string), _propTypes.string])]),
  columnCount: _propTypes.number,
  breakpoints: (0, _propTypes.objectOf)(_propTypes.number)
};
var styledFlexboxGrid = exports.styledFlexboxGrid = {
  breakpoints: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  rowWidth: (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]),
  gutter: (0, _propTypes.oneOfType)([(0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.number), _propTypes.number]), (0, _propTypes.oneOfType)([(0, _propTypes.objectOf)(_propTypes.string), _propTypes.string])]),
  columnCount: _propTypes.number,
  getColumnWidth: _propTypes.func,
  getGutterWidth: _propTypes.func
};